module.exports = __webpack_public_path__ + "static/media/drresume.29a37107.pdf";